import { Link, useNavigate } from "react-router-dom";
import { ContactUs } from "../../../../models";
import { useActionState, useEffect } from "react";
import FormBody from "../../../../components/form-body";
import Label from "../../../../components/label";
import Input from "../../../../components/input";
import FormError from "../../../../components/form-error";
import Textarea from "../../../../components/textarea";
import { Button } from "../../../../components/button";
import { State, updateContactUs } from "../actions";
import Toggle from "../../../../components/toggle";

export default function ContactUsForm({
  message,
}: {
  message: ContactUs;
}) {
  
  const navigate = useNavigate();
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      name: message.name,
      email: message.email,
      subject: message.subject,
      message: message.message,
      replayed: message.replayed,
    },
  };

  const updateContactUsWithId = updateContactUs.bind(null, message.id || "");
  const [state, formAction, isPending] = useActionState(
    updateContactUsWithId,
    initialState
  );
  useEffect(() => {
    if (state.success) {
      navigate("/admin/contact-us");
    }
  }, [state]);

  return (
    <form className="space-y-6 max-w-3xl py-8 text-left" action={formAction}>
      <FormBody>
        <div className="mb-4">
          <Label htmlFor="name">Name</Label>
          <Input
            id="name"
            name="name"
            type="text"
            placeholder="Enter name"
            aria-describedby="name-error"
            defaultValue={state.defaultValues?.name ?? ""}
            required
            readOnly
            className="bg-gray-100"
          />
          <FormError id="name-error" message={state.errors?.name} />
        </div>
        <div className="mb-4">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"            name="email"
            required
            aria-describedby="email-error"
            placeholder="Enter email"
            defaultValue={state.defaultValues?.email ?? ""}
            readOnly
            className="bg-gray-100"
          />
          <FormError id="email-error" message={state.errors?.email} />
        </div>
        <div className="mb-4">
          <Label htmlFor="subject">Subject</Label>
          <Input
            id="subject"
            name="subject"
            placeholder="Enter subject"
            aria-describedby="subject-error"
            defaultValue={state.defaultValues?.subject ?? ""}
            readOnly
            className="bg-gray-100"
          />
          <FormError id="subject-error" message={state.errors?.subject} />
        </div>
        <div className="mb-4">
          <Label htmlFor="message">Message</Label>
          <Textarea
            id="message"
            name="message"
            placeholder="Enter message"
            aria-describedby="message-error"
            defaultValue={state.defaultValues?.message ?? ""}
            readOnly
            className="bg-gray-100"
          />
          <FormError id="message-error" message={state.errors?.message} />
        </div>
        <div className="mb-4">
              <Label htmlFor="replayed">Replayed</Label>
            <Toggle
              id="replayed"

              name="replayed"
              checked={state.defaultValues?.replayed ?? false}
              onChange={() => {}}
              
            ></Toggle>
          
          <FormError id="replayed-error" message={state.errors?.replayed} />
        </div>
      </FormBody>
      <div className="mt-6 flex justify-end gap-4">
        <Link to="/admin/contact-us">
          <Button type="reset" disabled={isPending}>
            Cancel
          </Button>
        </Link>
         <Button
          type="button"
          onClick={() => {
            window.location.href = `mailto:${message.email}?subject=${message.subject}`;
          }}
          className="min-w-[90px]"
        >
          Send Email
        </Button>
        <Button
          type="submit"
          disabled={isPending}
          loading={isPending}
          className="min-w-[90px]"
        >
          Save Changes
        </Button>
       
        
      </div>
    </form>
  );
}